import React from "react";

const Washing_14 = React.forwardRef(
  ({ width = "32", height = "28", viewBox = "0 0 32 28", fill = "none", className }, ref) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 0L0 28H32L16 0ZM16 4.14815L3.55556 25.9259H8.08306L18.4113 8.36792L16 4.14815ZM16.0831 25.9259H11.5636L20.1264 11.3693L22.3533 15.2665L16.0831 25.9259ZM19.5636 25.9259H28.4444L24.0684 18.2678L19.5636 25.9259Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default Washing_14;
